// @flow
import * as React from 'react';
import moment from 'moment-timezone';

import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

import type { LocalizedData } from '@screens/Blog/types';

import { BLOG_ARTICLE } from '@routes';

import { Link } from '@i18n';

import { withTranslationContext } from '@lib';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import {
  StyledArticleCard,
  StyledImageCover,
  StyledInfoContainer,
  StyledTitleContainer,
  StyledTitle,
  StyledDateAndLinkContainer,
  StyledFontAwesomeIcon,
  StyledLink,
  StyledReadMore,
  StyledLeadContainer,
  StyledLead
} from './styles';

import type { Props } from './types';

const ArticlesListCard = ({
  slug,
  title,
  date,
  image,
  lead,
  i18n,
  scrollPosition
}: Props): React.Node => {
  moment.locale(i18n.language);

  const dateDisplay = `${moment(date).format('LL')}`;
  const [waitedLead, setWaitedLead] = React.useState('');

  React.useEffect(() => {
    setWaitedLead(lead);
  }, [lead]);

  return (
    <>
      <Link passHref href={BLOG_ARTICLE} params={{ slug }}>
        <StyledLink>
          <StyledArticleCard>
            <StyledImageCover>
              <LazyLoadImage
                scrollPosition={scrollPosition}
                src={image || '../../../../../../../static/images/Blog-default-image.jpg'}
                alt="Blog-Image"
                effect="blur"
              />
            </StyledImageCover>
            <StyledInfoContainer>
              <StyledTitleContainer>
                <StyledTitle>{title}</StyledTitle>
              </StyledTitleContainer>

              {lead && (
                <StyledLeadContainer>
                  <StyledLead dangerouslySetInnerHTML={{ __html: waitedLead }} />
                </StyledLeadContainer>
              )}

              <StyledDateAndLinkContainer>
                <span>{dateDisplay}</span>
                <StyledReadMore>
                  <StyledFontAwesomeIcon icon={faChevronRight} size="xs" />
                </StyledReadMore>
              </StyledDateAndLinkContainer>
            </StyledInfoContainer>
          </StyledArticleCard>
        </StyledLink>
      </Link>
    </>
  );
};

export default withTranslationContext<LocalizedData>(ArticlesListCard);
